import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';

const ServiceCard = ({ service }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="service-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="service-navigation-wrapper">
        <button 
          className="nav-button back-button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <FaArrowLeft />
          <span>Back</span>
        </button>
      </div>

      <div className="service-image-container">
        <img src={service.image} alt={service.title} className="service-image" />
        <div className="service-overlay">
          <span className="service-icon">{service.icon}</span>
        </div>
      </div>
      <div className="service-content">
        <h2 className="service-title">{service.title}</h2>
        <p className="service-short-desc">{service.shortDesc}</p>
        <ul className="service-features">
          {service.description.map((feature, idx) => (
            <li key={idx} className="service-feature">{feature}</li>
          ))}
        </ul>
        <Link to={service.link} className="service-button">
          Learn More <span className="button-arrow">→</span>
        </Link>
      </div>
    </motion.div>
  );
};

export default ServiceCard; 